import React from "react";

// Komponen kecil yang dipakai berulang di halaman admin. Gayanya ada di
// style/admin-ui.css.

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="adm-page-header">
    <div>
      <h1 className="adm-page-title">{title}</h1>
      {subtitle && <p className="adm-page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="adm-page-actions">{actions}</div>}
  </div>
);

export const SearchInput = ({ value, onChange, placeholder = "Search…", style }) => (
  <div className="adm-search" style={style}>
    <i className="bi bi-search"></i>
    <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
  </div>
);

export const EmptyState = ({ icon = "bi-inbox", title = "No data yet", text }) => (
  <div className="adm-empty">
    <i className={`bi ${icon}`}></i>
    <p className="adm-empty-title">{title}</p>
    {text && <p className="adm-empty-text">{text}</p>}
  </div>
);

export const Card = ({ title, subtitle, actions, children, flush = false, bodyClassName = "", className = "" }) => (
  <section className={`adm-card${flush ? " adm-card--flush" : ""} ${className}`.trim()}>
    {(title || actions) && (
      <div className="adm-card-header">
        <div>
          {title && <h2 className="adm-card-title">{title}</h2>}
          {subtitle && <p className="adm-card-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="adm-page-actions">{actions}</div>}
      </div>
    )}
    {flush ? children : <div className={`adm-card-body ${bodyClassName}`.trim()}>{children}</div>}
  </section>
);
